import { gql } from '@apollo/client';
import ErrorResultFragment from "../../../fragments/ErrorResult";
import CompanyFieldsFragment from "../../../fragments/CompanyFields";

const ADD_COMPANY = gql`
  mutation AddCompany(
    $companyId: Int!
    $networkId: Int!
    $parentCompanyId: Int
    $publicCompanyId: String
  ) {
    companyAdminContext {
      companyNetworks {
        addCompany(
          companyId: $companyId
          networkId: $networkId
          parentCompanyId: $parentCompanyId
          publicCompanyId: $publicCompanyId
        ) {
          errorResult {
            ...ErrorResultFields
          }
          result {
            ...CompanyRecursive
            ...CompanyFields
          }
          success
        }
      }
    }
  }

  fragment CompanyRecursive on Company {
    childCompanies {
      ...CompanyFields
      childCompanies {
        ...CompanyFields
        childCompanies {
          ...CompanyFields
        }
      }
    }
  }

  ${ErrorResultFragment}
  ${CompanyFieldsFragment}
`;

export default ADD_COMPANY;
